import 'whatwg-fetch';
import NProgress from 'nprogress';
import api, { checkStatus, parseJSON, errorResponse } from '../util/api';

export default function form(mainScroll) {
	let form = document.getElementById('form'),
		fileFields = form.querySelectorAll('input[type=file]'),
		requiredFields = form.getElementsByClassName('required-field'),
		successMessage = document.getElementById('success-message'),
		errorMessage = document.getElementById('error-message');

	NProgress.configure({ parent: '#progress' });

	/* Form Helpers */
	function resetMessages() {
		form.querySelectorAll('.form-error').forEach(f => {
			f.classList.remove('show');
		});
	}

	function resetFields() {
		const Inputs = form.querySelectorAll('input:not([type=submit]), textarea, select');
		[].forEach.call(Inputs, Input => {
			Input.value = '';
		});
	}

	function validateEmail(email) {
		// eslint-disable-next-line
		let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	}

	form.addEventListener('submit', ev => {
		ev.preventDefault();

		form.dataset.loading = 'true';

		// reset the form messages
		resetMessages();

		// Validate Everything
		let invalidFields = [];

		let makeInvalid = field => {
			invalidFields.push(field);
			form.querySelector('[data-error="' + field.id + '"]').classList.add('show');
		};

		let validateForm = fields => {
			for (let index = 0; index < fields.length; index++) {
				const required = fields[index];

				if (required.type == 'email') {
					if (!validateEmail(required.value)) {
						makeInvalid(required);
					}
				} else if (required.type == 'file' && required.files.length == 0) {
					makeInvalid(required);
				} else {
					if (!required.value) {
						makeInvalid(required);
					}
				}
			}

			// Scroll to first invalid field
			if (invalidFields.length > 0) {
				mainScroll.scrollTo(invalidFields[0]);
				return false;
			}

			return true;
		};

		// Append all present files
		let params = new FormData(form);
		params.append('_wpnonce', document.body.dataset.nonce);
		fileFields.forEach(file => {
			if (file.files.length > 0) {
				params.append(file.id, file.files[0]);
			}
		});

		if (validateForm(requiredFields)) {
			// ajax http post request
			NProgress.start();

			fetch(api.submit_application.form, {
				method: 'POST',
				body: params,
			})
				.then(checkStatus, NProgress.inc())
				.then(parseJSON, NProgress.inc())
				.then(response => {
					NProgress.done();
					if (response.code === 'sent-with-success') {
						resetFields();
						form.style.display = 'none';
						successMessage.style.display = 'block';
					}
				})
				.catch(error => {
					console.log('...', error);
					errorResponse(error);
					form.dataset.loading = 'false';
					errorMessage.style.display = 'block';
					NProgress.done();
				});
		}
	});
}



// WEBPACK FOOTER //
// ./scripts/components/form.js